var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-row", [_c("h2", [_vm._v("Rotas")])]),
      _vm._v(" "),
      _c("b-row", [
        _c("div", { staticClass: "col-md-12" }, [_c("bar-rotas")], 1)
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3", attrs: { "align-v": "end" } },
        [
          _c(
            "b-col",
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Usuário")]),
              _vm._v(" "),
              _c("b-form-select", {
                attrs: { options: _vm.listUsuarios },
                model: {
                  value: _vm.filtro.usuario,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "usuario", $$v)
                  },
                  expression: "filtro.usuario"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c("label", [_vm._v("Filtrar por Situação")]),
              _vm._v(" "),
              _c("b-form-select", {
                attrs: { options: _vm.listStatus },
                model: {
                  value: _vm.filtro.status,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "status", $$v)
                  },
                  expression: "filtro.status"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c("label", [_vm._v("Data de Partida")]),
              _vm._v(" "),
              _c("date-picker", {
                attrs: { config: _vm.datePickerConfig },
                model: {
                  value: _vm.filtro.dataPartida,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "dataPartida", $$v)
                  },
                  expression: "filtro.dataPartida"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c("label", [_vm._v("Data de Chegada")]),
              _vm._v(" "),
              _c("date-picker", {
                attrs: { config: _vm.datePickerConfig },
                model: {
                  value: _vm.filtro.dataChegada,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "dataChegada", $$v)
                  },
                  expression: "filtro.dataChegada"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", title: "Filtrar" },
                  on: {
                    click: function($event) {
                      return _vm.getRotas()
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-search" })]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary", title: "Limpar Filtros" },
                  on: {
                    click: function($event) {
                      return _vm.limparFiltro()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-history" })]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-table", {
            attrs: {
              items: _vm.rotas,
              fields: _vm.fields,
              busy: _vm.loading,
              hover: "",
              striped: "",
              small: "",
              stacked: "md",
              "show-empty": "",
              "empty-text": "Nenhuma rota encontrada ..."
            },
            scopedSlots: _vm._u([
              {
                key: "cell(actions)",
                fn: function(row) {
                  return [
                    _c("div", { staticClass: "custom-actions" }, [
                      _c(
                        "div",
                        { staticClass: "btn-group" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-outline-success",
                              attrs: {
                                title: "Relatório de Despesas",
                                href: "/adm/despesas/relatorio/" + row.item.id,
                                target: "_blank"
                              }
                            },
                            [_c("i", { staticClass: "fas fa-dollar-sign" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                title: "Relatório de Visitas",
                                href:
                                  "/adm/rotas/diario/relatorio/" + row.item.id,
                                target: "_blank"
                              }
                            },
                            [_c("i", { staticClass: "far fa-calendar-check" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "success",
                                title: "Aprovar Rota"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getAprova(row.item.id)
                                }
                              }
                            },
                            [_c("i", { staticClass: "far fa-thumbs-up" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "info" },
                              on: {
                                click: function($event) {
                                  return _vm.edite(row.item.id)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-edit" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "warning" },
                              on: {
                                click: function($event) {
                                  return _vm.delRota(row.item.id)
                                }
                              }
                            },
                            [_c("i", { staticClass: "far fa-trash-alt" })]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                }
              },
              {
                key: "table-busy",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "text-center text-primary my-2" },
                      [
                        _c("b-spinner", { staticClass: "align-middle" }),
                        _vm._v(" "),
                        _c("strong", [_vm._v("Carregando Rotas ...")])
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.rows > 15
            ? _c("b-pagination", {
                attrs: { "total-rows": _vm.rows, "per-page": _vm.perPage },
                on: {
                  input: function($event) {
                    return _vm.getRotas()
                  }
                },
                model: {
                  value: _vm.currentPage,
                  callback: function($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: _vm.titleModalAprova, size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _vm.admin > 0
                    ? _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "primary" },
                          on: { click: _vm.aprovaRota }
                        },
                        [_vm._v("\n                Salvar\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: {
                        click: function($event) {
                          _vm.modalAprova = false
                        }
                      }
                    },
                    [_vm._v("\n                Fechar\n            ")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalAprova,
            callback: function($$v) {
              _vm.modalAprova = $$v
            },
            expression: "modalAprova"
          }
        },
        [
          _c(
            "b-card",
            [
              _c("b-card-body", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-4" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v(" Situação ")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.status,
                              expression: "status"
                            }
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.status = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "APROVADO" } }, [
                            _vm._v("APROVADO")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "PARCIAL" } }, [
                            _vm._v("PARCIAL")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "BLOQUEADO" } }, [
                            _vm._v("BLOQUEADO")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "FINALIZADO" } }, [
                            _vm._v("FINALIZADO")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "EM ANALISE" } }, [
                            _vm._v("EM ANALISE")
                          ])
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "list-group" }, [
                      _c("div", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                                Total de Combustível: R$ " +
                            _vm._s(_vm.totalCombustivel) +
                            "\n                                "
                        ),
                        _c("small", { staticClass: "text-danger" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.totalLitros.toFixed(2)) +
                              " Litros\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                                Total Hospedagem : R$ " +
                            _vm._s(_vm.totalHospedagem) +
                            "\n                                "
                        ),
                        _c("small", { staticClass: "text-danger" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.parametros.hospedagem) +
                              " a diária\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                                Total Alimentação : R$ " +
                            _vm._s(_vm.totalAlimentacao) +
                            "\n                                "
                        ),
                        _c("small", { staticClass: "text-danger" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.parametros.alimentacao) +
                              " a diária\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                                Pedagio : R$ " +
                            _vm._s(_vm.totalPedagio.toFixed(2)) +
                            "\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-group-item active" }, [
                        _vm._v(
                          "\n                                Total : R$ " +
                            _vm._s(_vm.valorTOTAL) +
                            "\n                            "
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("table", { staticClass: "table table-hover" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Rota")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Endereco")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Cidade")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Km Extra")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Qt. SubRotas")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Pedágio")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.listaRotas, function(rota, i) {
                        return _c("tr", { key: i }, [
                          _c("td", [_vm._v(_vm._s(i + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(rota.endereco))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(rota.cidade))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(rota.km))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(rota.subrota))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(rota.pedagio))])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", { staticClass: "text-primary" }, [
                        _c("td", [_vm._v("-")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Total Km " + _vm._s(_vm.totalKM))]),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.totalkm_extra))])
                      ])
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "lg", title: "Parâmetros de Calculo de rotas" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "primary" },
                      on: { click: _vm.saveParametro }
                    },
                    [
                      _vm._v(
                        "\n                Salvar Parametros\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: {
                        click: function($event) {
                          _vm.modalParametros = false
                        }
                      }
                    },
                    [_vm._v("\n                Fechar\n            ")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalParametros,
            callback: function($$v) {
              _vm.modalParametros = $$v
            },
            expression: "modalParametros"
          }
        },
        [
          _c(
            "b-card",
            [
              _c("b-card-body", [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Km por Litro")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.km_litro,
                        expression: "km_litro"
                      },
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: ["##", "#"],
                        expression: "['##', '#']"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.km_litro },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.km_litro = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Km por Dia ")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.km_dia,
                        expression: "km_dia"
                      },
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: ["##", "###", "####"],
                        expression: "['##', '###', '####']"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.km_dia },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.km_dia = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Valor Médio de Hospedagem")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.valor_hospedagem,
                        expression: "valor_hospedagem"
                      },
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: ["#,##", "##,##", "###,##"],
                        expression: "['#,##', '##,##', '###,##']"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.valor_hospedagem },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.valor_hospedagem = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Valor Médio de alimentação por dia")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.valor_alimentacao,
                        expression: "valor_alimentacao"
                      },
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: ["#,##", "##,##"],
                        expression: "['#,##', '##,##']"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.valor_alimentacao },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.valor_alimentacao = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Valor médio do Combustível")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.valor_combustivel,
                        expression: "valor_combustivel"
                      },
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: ["#,##", "##,##"],
                        expression: "['#,##', '##,##']"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.valor_combustivel },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.valor_combustivel = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Km Extra")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.km_extra,
                        expression: "km_extra"
                      },
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: ["###"],
                        expression: "['###']"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.km_extra },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.km_extra = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a33dec4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a33dec4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/ListRotas.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4a33dec4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/ListRotas.vue
// module chunks = 2